import commonFunction from '@/common/commonFunction';
import { MSEnum } from '@/common/enumeration';

export default {
	FinanceYearStartDateData: function() {
		return commonFunction.getDataFromEnum('FinanceYearStartDateEnum');
	},
	taxPayerInfo(state) {
		return state.taxPayerInfo;
	},
	IsViewGuideUser(state) {
		return state.IsViewGuideUser;
	},
	/**
	 * Cờ đánh dấu là Hộ kinh doanh (HKD)
	 * @param {*} state
	 * @returns
	 */
	isIndividualTaxpayer(state) {
		return (
			state.taxPayerInfo &&
			state.taxPayerInfo.TaxpayerInfoType ===
				MSEnum.TaxpayerInfoType.Individual
		);
	},
	/**
	 * Cờ đánh dấu là cá nhân kinh doanh (CN)
	 * @param {*} state
	 * @returns
	 */
	isSoleTraderTaxpayer(state) {
		return (
			state.taxPayerInfo &&
			state.taxPayerInfo.TaxpayerInfoType ===
				MSEnum.TaxpayerInfoType.SoleTrader
		);
	},
	taxpayerTypeConfirmed(state) {
		return state.taxPayerInfo && state.taxPayerInfo.TaxpayerTypeConfirmed;
	},
	cqtPopupDismissed(state) {
		return state.cqtPopupDismissed;
	},
	amisConvertFailNotiShown(state) {
		return state.amisConvertFailNotiShown;
	},
	/**
	 * Cờ đánh dấu MST cần đăng nhập lại qua AMIS
	 * True khi: đã active từ AMIS hoặc đã Converted
	 * Dùng để gate các popup khác (vd: checkCQTFields) không show song song
	 * @param {*} state
	 * @returns {Boolean}
	 */
	amisRequiredLogin(state) {
		return (
			state.taxPayerInfo &&
			(state.taxPayerInfo.IsActiveFromAmis ===
				MSEnum.AmisActiveStatus.Active ||
				state.taxPayerInfo.AmisConvertStatus ===
					MSEnum.AmisConvertStatus.Converted)
		);
	},

	/**
	 * Cờ đánh dấu MST cần phải convert lên AMIS
	 * @param {*} state
	 * @returns {Boolean}
	 */
	taxPayerRequiredConvert(state) {
		return (
			state.taxPayerInfo &&
			state.taxPayerInfo.IsActiveFromAmis !=
				MSEnum.AmisActiveStatus.Active &&
			(state.taxPayerInfo.AmisConvertStatus ===
				MSEnum.AmisConvertStatus.NotConverted ||
				state.taxPayerInfo.AmisConvertStatus ===
					MSEnum.AmisConvertStatus.MutilTenant)
		);
	}
};
